(function () {
  'use strict';

  var SELECTOR_BUILD = '2026-10-14-gallery-videos-v4';
  var PINNED_GALLERY_MEDIA_ID = '46254044381484';
  var PINNED_GALLERY_SYNTHETIC_ID = '99083960187184';
  var PINNED_GALLERY_VIDEO_TOKEN = 'c0836d91b7184396a222b88701a4faa8';
  var PINNED_GALLERY_VIDEO_URL = 'https://cdn.shopify.com/videos/c/o/v/c0836d91b7184396a222b88701a4faa8.mp4';
  var ENDING_GALLERY_SYNTHETIC_ID = '99083960187185';
  var ENDING_GALLERY_VIDEO_TOKEN = '9156d0bf0ed14371b66f862fbc5b1565';
  var ENDING_GALLERY_VIDEO_URL = 'https://cdn.shopify.com/videos/c/o/v/9156d0bf0ed14371b66f862fbc5b1565.mp4';

  var PRESETS = {
    two: {
      label: 'Sofá 2 cuerpos',
      counts: { seat: 2, back: 2, chaise: 0 }
    },
    three: {
      label: 'Sofá 3 cuerpos',
      counts: { seat: 3, back: 3, chaise: 0 }
    },
    sectional: {
      label: 'Sofá seccional 2 cuerpos',
      counts: { seat: 2, back: 3, chaise: 1 }
    },
    custom: {
      label: 'Personalizado',
      counts: null
    }
  };

  var PIECES = {
    seat: { singular: 'funda de asiento', plural: 'fundas de asiento' },
    back: { singular: 'funda de respaldo', plural: 'fundas de respaldo' },
    chaise: { singular: 'funda chaise longue', plural: 'fundas chaise longue' }
  };

  var COLOR_STYLES = {
    'gris claro': '#b9b7b2',
    'gris oscuro': '#575957',
    'caqui': '#a28f72',
    'crema': '#eee4cf',
    'blanco': '#f7f6f1',
    'cafe oscuro': '#5f4638',
    'café oscuro': '#5f4638',
    'negro': '#242424'
  };

  function normalize(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  function clamp(value, min, max) {
    var number = parseInt(value, 10);
    if (Number.isNaN(number)) number = min;
    return Math.min(max, Math.max(min, number));
  }

  function shippingState(total, threshold) {
    var solutionTotal = Math.max(0, Number(total || 0));
    var shippingThreshold = Math.max(0, Number(threshold || 0));
    var remaining = Math.max(0, shippingThreshold - solutionTotal);

    return {
      remaining: remaining,
      progress: shippingThreshold ? Math.min(100, (solutionTotal / shippingThreshold) * 100) : 0,
      complete: shippingThreshold > 0 && remaining === 0
    };
  }

  function copyCounts(counts) {
    return {
      seat: counts.seat || 0,
      back: counts.back || 0,
      chaise: counts.chaise || 0
    };
  }

  function detectPiece(value) {
    var label = normalize(value);
    var matches = [];
    if (label.indexOf('chaise') !== -1 || label.indexOf('lateral') !== -1 || label.indexOf('seccional') !== -1 || /\ben l\b/.test(label)) matches.push('chaise');
    if (label.indexOf('respaldo') !== -1 || label.indexOf('trasero') !== -1) matches.push('back');
    if (label.indexOf('asiento') !== -1 || label.indexOf('base') !== -1) matches.push('seat');
    if (matches.length === 1) return matches[0];
    return null;
  }

  function parsePackQuantity(value) {
    var label = normalize(value);
    var match = label.match(/(\d+)\s*(?:fundas?|cojines?|unidades?)/);
    if (match) return Math.max(parseInt(match[1], 10) || 1, 1);

    match = label.match(/(?:^|\s)(?:pack(?:\s+de)?|x)\s*([1-8])\b/);
    if (match) return Math.max(parseInt(match[1], 10) || 1, 1);
    return 1;
  }

  function detectOptionIndexes(options, variants) {
    var colorIndex = -1;
    var pieceIndex = -1;

    options.forEach(function (option, index) {
      var name = normalize(option);
      if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1) colorIndex = index;
    });

    options.forEach(function (_option, index) {
      if (index === colorIndex || pieceIndex !== -1) return;
      var hasPiece = variants.some(function (variant) {
        return Boolean(detectPiece(variant.options && variant.options[index]));
      });
      if (hasPiece) pieceIndex = index;
    });

    if (pieceIndex === -1 && options.length > 0) pieceIndex = colorIndex === 0 ? 1 : 0;
    if (colorIndex === -1 && options.length > 1) colorIndex = pieceIndex === 0 ? 1 : 0;

    return { piece: pieceIndex, color: colorIndex };
  }

  function createModel(config) {
    var variants = Array.isArray(config.variants) ? config.variants : [];
    var indexes = detectOptionIndexes(config.options || [], variants);
    var colors = [];
    var colorLabels = {};
    var byPiece = { seat: {}, back: {}, chaise: {} };

    variants.forEach(function (variant) {
      var variantOptions = variant.options || [];
      var coverLabel = variantOptions[indexes.piece];
      var piece = detectPiece(coverLabel);
      var colorLabel = variantOptions[indexes.color];
      var colorKey = normalize(colorLabel);

      if (!piece || !colorKey) return;
      if (colors.indexOf(colorKey) === -1) {
        colors.push(colorKey);
        colorLabels[colorKey] = colorLabel;
      }

      if (!byPiece[piece][colorKey]) byPiece[piece][colorKey] = [];
      byPiece[piece][colorKey].push({
        variant: variant,
        packSize: parsePackQuantity(coverLabel)
      });
    });

    Object.keys(byPiece).forEach(function (piece) {
      Object.keys(byPiece[piece]).forEach(function (color) {
        byPiece[piece][color].sort(function (left, right) {
          return right.packSize - left.packSize;
        });
      });
    });

    return {
      colors: colors,
      colorLabels: colorLabels,
      byPiece: byPiece
    };
  }

  function visualConfigurationKey(value) {
    var label = normalize(value);
    if (label.indexOf('seccional') !== -1 || label.indexOf('chaise') !== -1 || /\ben l\b/.test(label)) return 'sectional';
    if (/\b3\b/.test(label) || label.indexOf('tres') !== -1) return 'three';
    if (/\b2\b/.test(label) || label.indexOf('dos') !== -1) return 'two';
    return null;
  }

  function selectedVisualConfiguration(preset, counts) {
    if (preset !== 'custom') return preset;
    if (Number(counts.chaise || 0) > 0) return 'sectional';
    if (Math.max(Number(counts.seat || 0), Number(counts.back || 0)) >= 3) return 'three';
    return 'two';
  }

  function detectHostOptionIndexes(options, variants) {
    var colorIndex = -1;
    var configurationIndex = -1;

    options.forEach(function (option, index) {
      var name = normalize(option);
      if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1) colorIndex = index;
      if (
        name.indexOf('config') !== -1 ||
        name.indexOf('sofa') !== -1 ||
        name.indexOf('fundas seleccionadas') !== -1
      ) configurationIndex = index;
    });

    if (configurationIndex === -1) {
      options.forEach(function (_option, index) {
        if (index === colorIndex || configurationIndex !== -1) return;
        var hasConfiguration = variants.some(function (variant) {
          return Boolean(visualConfigurationKey(variant.options && variant.options[index]));
        });
        if (hasConfiguration) configurationIndex = index;
      });
    }

    if (configurationIndex === -1 && options.length) configurationIndex = colorIndex === 0 ? 1 : 0;
    if (colorIndex === -1 && options.length > 1) colorIndex = configurationIndex === 0 ? 1 : 0;

    return { configuration: configurationIndex, color: colorIndex };
  }

  function createHostMediaModel(config) {
    var variants = Array.isArray(config.hostVariants) ? config.hostVariants : [];
    var indexes = detectHostOptionIndexes(config.hostOptions || [], variants);

    return variants.map(function (variant) {
      var options = Array.isArray(variant.options) ? variant.options : [];
      return {
        id: variant.id,
        configuration: visualConfigurationKey(options[indexes.configuration]),
        color: normalize(options[indexes.color]),
        featuredMediaId: variant.featuredMediaId ? String(variant.featuredMediaId) : '',
        featuredMediaUrl: variant.featuredMediaUrl || '',
        featuredMediaAlt: variant.featuredMediaAlt || ''
      };
    }).filter(function (variant) {
      return Boolean(variant.configuration && variant.color && variant.featuredMediaId);
    });
  }

  function findHostMediaVariant(hostMediaModel, preset, counts, color) {
    var configuration = selectedVisualConfiguration(preset, counts);
    var normalizedColor = normalize(color);

    return hostMediaModel.find(function (variant) {
      return variant.configuration === configuration && variant.color === normalizedColor;
    }) || null;
  }

  function normalizeMediaColor(value) {
    return normalize(value)
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function extractMediaId(value) {
    var matches = String(value || '').match(/\d+/g);
    return matches && matches.length ? matches[matches.length - 1] : '';
  }

  function readMediaColor(element) {
    if (!element) return '';
    if (element.dataset.tdFcMediaColor) return element.dataset.tdFcMediaColor;

    var color = '';
    Array.prototype.slice.call(element.querySelectorAll('img[alt]')).forEach(function (image) {
      var alt = image.getAttribute('alt') || '';
      var match = alt.match(/\[(?:td-color|td-fm-color)\s*[:=]\s*([^\]]+)\]\s*/i);
      if (!match) return;
      if (!color) color = normalizeMediaColor(match[1]);
      image.setAttribute('alt', alt.replace(match[0], '').trim());
    });

    if (color) element.dataset.tdFcMediaColor = color;
    return color;
  }

  function hydrateMedia(element) {
    if (!element) return;
    Array.prototype.slice.call(element.querySelectorAll('[data-td-funda-srcset], [data-td-funda-src]')).forEach(function (image) {
      var srcset = image.getAttribute('data-td-funda-srcset');
      var src = image.getAttribute('data-td-funda-src');
      if (srcset) image.setAttribute('srcset', srcset);
      if (src) image.setAttribute('src', src);
      image.removeAttribute('data-td-funda-srcset');
      image.removeAttribute('data-td-funda-src');
      image.removeAttribute('data-td-funda-network-deferred');
    });
  }

  function setMediaVisible(element, visible) {
    if (!element) return;
    if (visible) hydrateMedia(element);
    if (!visible) {
      Array.prototype.slice.call(element.querySelectorAll('video')).forEach(function (video) {
        if (typeof video.pause === 'function') video.pause();
      });
      element.classList.remove('is-active', 'is-active-media-thumbnail');
      Array.prototype.slice.call(element.querySelectorAll('button[aria-current]')).forEach(function (button) {
        button.removeAttribute('aria-current');
      });
    }
    element.hidden = !visible;
    element.style.display = visible ? '' : 'none';
    element.setAttribute('aria-hidden', String(!visible));
  }

  function availablePackCopies(variant, desiredCopies) {
    if (!variant || !variant.available) return 0;
    if (!variant.inventoryManagement || variant.inventoryPolicy === 'continue') return desiredCopies;
    return Math.max(0, Math.min(desiredCopies, Number(variant.inventoryQuantity || 0)));
  }

  function isBetterPlan(candidate, current) {
    if (!current) return true;
    if (candidate.price !== current.price) return candidate.price < current.price;
    if (candidate.cartQuantity !== current.cartQuantity) return candidate.cartQuantity < current.cartQuantity;
    return candidate.items.length < current.items.length;
  }

  function planPiece(model, piece, color, requestedUnits) {
    var units = Number(requestedUnits || 0);
    if (!units) return { price: 0, compare: 0, cartQuantity: 0, items: [] };

    var options = model.byPiece[piece] && model.byPiece[piece][color];
    if (!options || !options.length) return null;

    var plans = new Array(units + 1).fill(null);
    plans[0] = { price: 0, compare: 0, cartQuantity: 0, items: [] };

    options.forEach(function (entry) {
      var packSize = Number(entry.packSize || 1);
      if (packSize > units) return;

      var previous = plans.slice();
      var next = plans.slice();

      previous.forEach(function (base, coveredUnits) {
        if (!base) return;
        var remainingUnits = units - coveredUnits;
        var desiredCopies = Math.floor(remainingUnits / packSize);
        var maxCopies = availablePackCopies(entry.variant, desiredCopies);

        for (var copies = 1; copies <= maxCopies; copies += 1) {
          var targetUnits = coveredUnits + (packSize * copies);
          var price = Number(entry.variant.price || 0) * copies;
          var compare = Number(entry.variant.compare_at_price || entry.variant.price || 0) * copies;
          var candidate = {
            price: base.price + price,
            compare: base.compare + compare,
            cartQuantity: base.cartQuantity + copies,
            items: base.items.concat([{
              variant: entry.variant,
              packSize: packSize,
              quantity: copies
            }])
          };

          if (isBetterPlan(candidate, next[targetUnits])) next[targetUnits] = candidate;
        }
      });

      plans = next;
    });

    return plans[units];
  }

  function planSolution(model, counts, color) {
    if (!color) return null;

    var result = { price: 0, compare: 0, plans: {} };
    var pieces = Object.keys(PIECES);

    for (var index = 0; index < pieces.length; index += 1) {
      var piece = pieces[index];
      var units = Number(counts[piece] || 0);
      if (!units) continue;

      var piecePlan = planPiece(model, piece, color, units);
      if (!piecePlan) return null;
      result.plans[piece] = piecePlan;
      result.price += piecePlan.price;
      result.compare += piecePlan.compare;
    }

    return result;
  }

  function lowestSolution(model, counts) {
    return model.colors.reduce(function (lowest, color) {
      var candidate = planSolution(model, counts, color);
      if (!candidate) return lowest;
      if (!lowest || candidate.price < lowest.price) return candidate;
      return lowest;
    }, null);
  }

  function showInitializationError(root) {
    root.classList.add('has-error');
    var error = root.querySelector('[data-td-fc-error]');
    var errorMessage = root.querySelector('[data-td-fc-error-message]');
    var submit = root.querySelector('[data-td-fc-submit]');
    var submitLabel = root.querySelector('[data-td-fc-submit-label]');
    if (error) {
      if (errorMessage) errorMessage.textContent = 'No pudimos cargar las combinaciones. Recarga la página o usa la compra individual.';
      error.hidden = false;
    }
    if (submit) submit.disabled = true;
    if (submitLabel) submitLabel.textContent = 'Configurador no disponible';
  }

  function initialize(root) {
    root.dataset.tdFcSelectorBuild = SELECTOR_BUILD;
    if (root.dataset.tdFundaCompleteReady === 'true') return;

    var configNode = root.querySelector('[data-td-fc-config]');
    if (!configNode) return;

    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (error) {
      showInitializationError(root);
      return;
    }

    var model = createModel(config);
    var hostMediaModel = createHostMediaModel(config);
    if (!model.colors.length) {
      showInitializationError(root);
      return;
    }

    root.dataset.tdFundaCompleteReady = 'true';

    var elements = {
      presetButtons: Array.prototype.slice.call(root.querySelectorAll('[data-td-fc-preset]')),
      customPanel: root.querySelector('[data-td-fc-custom]'),
      steppers: Array.prototype.slice.call(root.querySelectorAll('[data-td-fc-stepper]')),
      media: root.querySelector('[data-td-fc-media]'),
      mediaImage: root.querySelector('[data-td-fc-media-image]'),
      mediaCaption: root.querySelector('[data-td-fc-media-caption]'),
      colors: root.querySelector('[data-td-fc-colors]'),
      colorName: root.querySelector('[data-td-fc-color-name]'),
      summaryName: root.querySelector('[data-td-fc-summary-name]'),
      summaryCount: root.querySelector('[data-td-fc-count]'),
      summaryLines: root.querySelector('[data-td-fc-summary-lines]'),
      compare: root.querySelector('[data-td-fc-compare]'),
      total: root.querySelector('[data-td-fc-total]'),
      shipping: root.querySelector('[data-td-fc-shipping]'),
      shippingText: root.querySelector('[data-td-fc-shipping-text]'),
      shippingAmount: root.querySelector('[data-td-fc-shipping-amount]'),
      shippingProgress: root.querySelector('[data-td-fc-shipping-progress]'),
      error: root.querySelector('[data-td-fc-error]'),
      errorMessage: root.querySelector('[data-td-fc-error-message]'),
      submit: root.querySelector('[data-td-fc-submit]'),
      submitLabel: root.querySelector('[data-td-fc-submit-label]')
    };

    var state = {
      preset: 'two',
      color: null,
      customCounts: copyCounts(PRESETS.two.counts),
      loading: false,
      pendingBundleKey: null,
      mediaFrame: null,
      selectedHostVariant: null,
      mediaNaturalPositions: {},
      pinnedGalleryMediaId: PINNED_GALLERY_MEDIA_ID,
      endingGalleryMediaId: ENDING_GALLERY_SYNTHETIC_ID
    };

    var sectionId = root.dataset.sectionId || '';
    var galleryConfig = { mediaGroups: {} };
    var galleryConfigNode = sectionId ? document.getElementById('VariantMediaConfig-' + sectionId) : null;
    if (galleryConfigNode) {
      try {
        galleryConfig = JSON.parse(galleryConfigNode.textContent);
      } catch (error) {
        console.warn('[TD Funda Complete] No pudimos leer el mapa de imágenes.', error);
      }
    }

    var entrySolution = lowestSolution(model, PRESETS.two.counts);
    if (entrySolution) {
      root.dataset.tdFcEntryPrice = String(entrySolution.price);
      root.dataset.tdFcEntryPriceFormatted = money(entrySolution.price);
      if (entrySolution.compare > entrySolution.price) {
        root.dataset.tdFcEntryCompare = String(entrySolution.compare);
        root.dataset.tdFcEntryCompareFormatted = money(entrySolution.compare);
      }
    }

    function handleRadioKeys(event, buttons) {
      var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
      if (keys.indexOf(event.key) === -1) return;

      var enabled = buttons.filter(function (button) { return !button.disabled; });
      if (!enabled.length) return;

      event.preventDefault();
      var currentIndex = enabled.indexOf(event.currentTarget);
      var nextIndex = currentIndex;

      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = enabled.length - 1;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % enabled.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + enabled.length) % enabled.length;

      var next = enabled[nextIndex];
      var nextColor = next.dataset.color;
      var nextPreset = next.dataset.tdFcPreset;
      next.focus();
      next.click();

      window.requestAnimationFrame(function () {
        var replacement = next;
        if (!next.isConnected && nextColor) {
          replacement = Array.prototype.slice.call(elements.colors.querySelectorAll('[role="radio"]')).find(function (button) {
            return button.dataset.color === nextColor;
          });
        } else if (!next.isConnected && nextPreset) {
          replacement = elements.presetButtons.find(function (button) {
            return button.dataset.tdFcPreset === nextPreset;
          });
        }
        if (replacement) replacement.focus({ preventScroll: true });
      });
    }

    function money(cents) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat(config.locale || 'es-CL', {
          style: 'currency',
          currency: config.currency || 'CLP',
          maximumFractionDigits: 0
        }).format(amount);
      } catch (_error) {
        return '$' + Math.round(amount).toLocaleString('es-CL');
      }
    }

    function getCounts() {
      if (state.preset === 'custom') return copyCounts(state.customCounts);
      return copyCounts(PRESETS[state.preset].counts);
    }

    function totalPieces(counts) {
      return counts.seat + counts.back + counts.chaise;
    }

    function bundleContentsLabel(counts) {
      return Object.keys(PIECES).reduce(function (labels, piece) {
        var quantity = Number(counts[piece] || 0);
        if (!quantity) return labels;

        labels.push(quantity + ' ' + (quantity === 1 ? PIECES[piece].singular : PIECES[piece].plural));
        return labels;
      }, []).join(' · ');
    }

    function bundleDisplayMetadata(counts, colorLabel, shopRoot) {
      var preset = PRESETS[state.preset] || PRESETS.custom;
      var handle = String(config.hostProductHandle || '').trim();
      var rootUrl = String(shopRoot || '/').replace(/\/?$/, '/');
      var visualVariant = findHostMediaVariant(hostMediaModel, state.preset, counts, colorLabel) || state.selectedHostVariant;
      var imageUrl = visualVariant && visualVariant.featuredMediaUrl
        ? String(visualVariant.featuredMediaUrl)
        : '';

      if (imageUrl.indexOf('//') === 0) imageUrl = 'https:' + imageUrl;

      return {
        '_td_bundle_title': 'Funda Mágica Completa',
        '_td_bundle_configuration': preset.label,
        '_td_bundle_color': String(colorLabel || ''),
        '_td_bundle_seat': String(Number(counts.seat || 0)),
        '_td_bundle_back': String(Number(counts.back || 0)),
        '_td_bundle_chaise': String(Number(counts.chaise || 0)),
        '_td_bundle_includes': bundleContentsLabel(counts),
        '_td_bundle_image': imageUrl,
        '_td_bundle_url': handle ? rootUrl + 'products/' + encodeURIComponent(handle) : ''
      };
    }

    function mediaDescriptor(element) {
      if (!element) return '';
      var image = element.querySelector('img');
      if (!image) return '';

      return normalize([
        image.getAttribute('alt') || '',
        image.currentSrc || '',
        image.getAttribute('src') || '',
        image.getAttribute('data-td-funda-src') || '',
        image.getAttribute('srcset') || '',
        image.getAttribute('data-td-funda-srcset') || ''
      ].join(' ')).replace(/[_-]+/g, ' ');
    }

    function mediaSourceDescriptor(element) {
      if (!element) return '';
      var image = element.querySelector('img');
      if (!image) return '';

      return normalize([
        image.currentSrc || '',
        image.getAttribute('src') || '',
        image.getAttribute('data-td-funda-src') || '',
        image.getAttribute('srcset') || '',
        image.getAttribute('data-td-funda-srcset') || ''
      ].join(' ')).replace(/[_-]+/g, ' ');
    }

    function galleryVideoPlayIcon() {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8.2 5.6v12.8L18.8 12 8.2 5.6Z" fill="currentColor"></path></svg>';
    }

    function ensureGalleryVideoStyles() {
      if (document.getElementById('TdFcGalleryVideoStyles')) return;

      var style = document.createElement('style');
      style.id = 'TdFcGalleryVideoStyles';
      style.textContent = [
        '.td-fc-gallery-video__stage{padding-top:100%;background:#171715;}',
        '.td-fc-gallery-video__stage>video{object-fit:cover;background:#171715;}',
        '.td-fc-gallery-video__preview{width:100%;height:100%;object-fit:cover;background:#171715;pointer-events:none;}',
        '.td-fc-gallery-video__poster{display:flex!important;align-items:center;justify-content:center;background:linear-gradient(145deg,#292823 0%,#11110f 100%);color:#fff;}',
        '.td-fc-gallery-video__poster:after{content:"";position:absolute;inset:55% 0 0;background:linear-gradient(180deg,transparent,rgba(0,0,0,.38));pointer-events:none;}',
        '.td-fc-gallery-video__poster .deferred-media__poster-button{z-index:2;background:rgba(255,255,255,.96);color:#171715;}',
        '.td-fc-gallery-video__poster .deferred-media__poster-button svg{width:2rem;height:2rem;margin-left:.2rem;}',
        '.td-fc-gallery-video__poster-label{position:absolute;right:0;bottom:2.4rem;left:0;z-index:2;font-size:1.2rem;font-weight:650;letter-spacing:.14em;text-align:center;text-transform:uppercase;text-shadow:0 1px 6px rgba(0,0,0,.5);}',
        '.td-fc-gallery-video__thumbnail-button{position:relative;display:flex!important;align-items:center;justify-content:center;width:100%;height:100%;min-height:4.4rem;overflow:hidden;background:#171715;color:#fff;}',
        '.td-fc-gallery-video__thumbnail-button>video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;pointer-events:none;}',
        '.td-fc-gallery-video__thumbnail-button:after{content:"";position:absolute;inset:0;background:rgba(0,0,0,.2);pointer-events:none;}',
        '.td-fc-gallery-video__thumbnail-content{position:relative;z-index:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.35rem;}',
        '.td-fc-gallery-video__thumbnail-icon{display:flex;align-items:center;justify-content:center;width:2.6rem;height:2.6rem;border-radius:50%;background:#fff;color:#171715;box-shadow:0 2px 10px rgba(0,0,0,.2);}',
        '.td-fc-gallery-video__thumbnail-icon svg{width:1.2rem;height:1.2rem;margin-left:.1rem;}',
        '.td-fc-gallery-video__thumbnail-label{font-size:.8rem;font-weight:700;letter-spacing:.1em;line-height:1;text-shadow:0 1px 5px rgba(0,0,0,.6);text-transform:uppercase;}',
        '@media screen and (max-width:749px){.td-fc-gallery-video__poster-label{bottom:1.8rem;font-size:1.1rem}.td-fc-gallery-video__thumbnail-label{font-size:.72rem}}'
      ].join('');
      document.head.appendChild(style);
    }

    function ensurePinnedGalleryVideo(gallery) {
      if (!gallery) return null;

      ensureGalleryVideoStyles();

      var gallerySectionId = sectionId || String(gallery.id || '').replace(/^MediaGallery-/, '');
      var mediaList = gallery.querySelector('[id^="Slider-Gallery-"]');
      if (!mediaList) return null;

      var nativeSlide = Array.prototype.slice.call(
        gallery.querySelectorAll('.product__media-item[data-media-id]')
      ).find(function (candidate) {
        if (candidate.dataset.tdFcCustomGalleryVideo === 'true') return false;
        var candidateId = extractMediaId(candidate.dataset.mediaId);
        if (candidateId === PINNED_GALLERY_MEDIA_ID) return true;

        var template = candidate.querySelector('template');
        var descriptor = [
          mediaSourceDescriptor(candidate),
          template ? String(template.innerHTML || '').toLowerCase() : '',
          Array.prototype.slice.call(candidate.querySelectorAll('video, source')).map(function (media) {
            return String(media.currentSrc || media.src || media.getAttribute('src') || '').toLowerCase();
          }).join(' ')
        ].join(' ');
        return descriptor.indexOf(PINNED_GALLERY_VIDEO_TOKEN) !== -1;
      });

      if (nativeSlide) {
        var nativeMediaId = extractMediaId(nativeSlide.dataset.mediaId);
        state.pinnedGalleryMediaId = nativeMediaId;
        nativeSlide.dataset.tdFcPinnedGalleryVideo = 'true';

        var customSlide = gallery.querySelector('[data-td-fc-custom-gallery-video="true"]');
        var customThumbnail = gallery.querySelector('[data-td-fc-custom-gallery-video-thumbnail="true"]');
        if (customSlide) customSlide.remove();
        if (customThumbnail) customThumbnail.remove();

        Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item[data-target]')).forEach(function (item) {
          if (extractMediaId(item.dataset.target) === nativeMediaId) {
            item.dataset.tdFcPinnedGalleryVideo = 'true';
          }
        });
        return nativeSlide;
      }

      var galleryMediaId = gallerySectionId + '-' + PINNED_GALLERY_SYNTHETIC_ID;
      var slide = gallery.querySelector('[data-td-fc-custom-gallery-video="true"]');
      if (!slide) {
        var slideTemplate = document.createElement('template');
        slideTemplate.innerHTML = [
          '<li id="Slide-' + galleryMediaId + '" class="product__media-item grid__item slider__slide product__media-item--full td-fc-gallery-video" data-media-id="' + galleryMediaId + '" data-td-fc-custom-gallery-video="true" data-td-fc-pinned-gallery-video="true" data-td-fc-natural-position="2" role="presentation" aria-hidden="true">',
          '<div class="product__modal-opener product__modal-opener--video no-js-hidden td-fc-gallery-video__placeholder" aria-hidden="true">',
          '<span class="product__media-icon motion-reduce quick-add-hidden">' + galleryVideoPlayIcon() + '</span>',
          '<div class="product__media media media--transparent gradient global-media-settings" style="padding-top:100%">',
          '<video class="td-fc-gallery-video__preview" muted playsinline webkit-playsinline preload="metadata" src="' + PINNED_GALLERY_VIDEO_URL + '#t=0.001" tabindex="-1" aria-hidden="true"></video>',
          '</div>',
          '</div>',
          '<deferred-media class="deferred-media gradient global-media-settings media no-js-hidden td-fc-gallery-video__stage" style="padding-top:100%" data-media-id="' + PINNED_GALLERY_SYNTHETIC_ID + '" data-autoplay-when-active="true" data-enable-audio-on-tap="true">',
          '<button id="Deferred-Poster-' + galleryMediaId + '" class="deferred-media__poster td-fc-gallery-video__poster" type="button" aria-label="Reproducir video de Funda Mágica">',
          '<span class="deferred-media__poster-button motion-reduce" aria-hidden="true">' + galleryVideoPlayIcon() + '</span>',
          '<span class="td-fc-gallery-video__poster-label" aria-hidden="true">Ver Funda Mágica en acción</span>',
          '</button>',
          '<template><video muted playsinline webkit-playsinline loop preload="metadata" aria-label="Funda Mágica en acción"><source src="' + PINNED_GALLERY_VIDEO_URL + '" type="video/mp4"></video></template>',
          '</deferred-media>',
          '</li>'
        ].join('');
        slide = slideTemplate.content.firstElementChild;
        mediaList.appendChild(slide);
      }

      state.pinnedGalleryMediaId = PINNED_GALLERY_SYNTHETIC_ID;

      var thumbnailList = gallery.querySelector('[id^="Slider-Thumbnails-"]') || gallery.querySelector('.thumbnail-list');
      var thumbnail = gallery.querySelector('[data-td-fc-custom-gallery-video-thumbnail="true"]');
      if (thumbnailList && !thumbnail) {
        thumbnail = document.createElement('li');
        thumbnail.id = 'Slide-Thumbnails-' + gallerySectionId + '-video';
        thumbnail.className = 'thumbnail-list__item slider__slide td-fc-gallery-video__thumbnail';
        thumbnail.dataset.target = galleryMediaId;
        thumbnail.dataset.mediaPosition = '2';
        thumbnail.dataset.mediaNaturalPosition = '2';
        thumbnail.dataset.thumbnailInitialPosition = '2';
        thumbnail.dataset.tdFcNaturalPosition = '2';
        thumbnail.dataset.tdFcPinnedGalleryVideo = 'true';
        thumbnail.dataset.tdFcCustomGalleryVideoThumbnail = 'true';
        thumbnail.setAttribute('aria-hidden', 'false');

        var thumbnailButton = document.createElement('button');
        thumbnailButton.type = 'button';
        thumbnailButton.className = 'thumbnail global-media-settings global-media-settings--no-shadow td-fc-gallery-video__thumbnail-button';
        thumbnailButton.setAttribute('aria-label', 'Cargar el video 2 en la vista de la galería');
        thumbnailButton.setAttribute('aria-controls', 'GalleryViewer-' + gallerySectionId);
        thumbnailButton.innerHTML = [
          '<video muted playsinline webkit-playsinline preload="metadata" src="' + PINNED_GALLERY_VIDEO_URL + '#t=0.001" tabindex="-1" aria-hidden="true"></video>',
          '<span class="td-fc-gallery-video__thumbnail-content" aria-hidden="true">',
          '<span class="td-fc-gallery-video__thumbnail-icon">' + galleryVideoPlayIcon() + '</span>',
          '<span class="td-fc-gallery-video__thumbnail-label">Video</span>',
          '</span>'
        ].join('');
        thumbnailButton.addEventListener('click', function (event) {
          event.preventDefault();
          if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(galleryMediaId, false);
        });

        thumbnail.appendChild(thumbnailButton);
        thumbnailList.appendChild(thumbnail);
      }

      return slide;
    }

    function ensureEndingGalleryVideo(gallery) {
      if (!gallery) return null;

      ensureGalleryVideoStyles();

      var gallerySectionId = sectionId || String(gallery.id || '').replace(/^MediaGallery-/, '');
      var mediaList = gallery.querySelector('[id^="Slider-Gallery-"]');
      if (!mediaList) return null;

      var nativeSlide = Array.prototype.slice.call(
        gallery.querySelectorAll('.product__media-item[data-media-id]')
      ).find(function (candidate) {
        if (
          candidate.dataset.tdFcCustomGalleryVideo === 'true' ||
          candidate.dataset.tdFcCustomEndingGalleryVideo === 'true'
        ) return false;

        var template = candidate.querySelector('template');
        var descriptor = [
          mediaSourceDescriptor(candidate),
          template ? String(template.innerHTML || '').toLowerCase() : '',
          Array.prototype.slice.call(candidate.querySelectorAll('video, source')).map(function (media) {
            return String(media.currentSrc || media.src || media.getAttribute('src') || '').toLowerCase();
          }).join(' ')
        ].join(' ');
        return descriptor.indexOf(ENDING_GALLERY_VIDEO_TOKEN) !== -1;
      });

      if (nativeSlide) {
        var nativeMediaId = extractMediaId(nativeSlide.dataset.mediaId);
        state.endingGalleryMediaId = nativeMediaId;
        nativeSlide.dataset.tdFcEndingGalleryVideo = 'true';

        var customSlide = gallery.querySelector('[data-td-fc-custom-ending-gallery-video="true"]');
        var customThumbnail = gallery.querySelector('[data-td-fc-custom-ending-gallery-video-thumbnail="true"]');
        if (customSlide) customSlide.remove();
        if (customThumbnail) customThumbnail.remove();

        Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item[data-target]')).forEach(function (item) {
          if (extractMediaId(item.dataset.target) === nativeMediaId) {
            item.dataset.tdFcEndingGalleryVideo = 'true';
          }
        });
        return nativeSlide;
      }

      var galleryMediaId = gallerySectionId + '-' + ENDING_GALLERY_SYNTHETIC_ID;
      var slide = gallery.querySelector('[data-td-fc-custom-ending-gallery-video="true"]');
      if (!slide) {
        var slideTemplate = document.createElement('template');
        slideTemplate.innerHTML = [
          '<li id="Slide-' + galleryMediaId + '" class="product__media-item grid__item slider__slide product__media-item--full td-fc-gallery-video" data-media-id="' + galleryMediaId + '" data-td-fc-custom-ending-gallery-video="true" data-td-fc-ending-gallery-video="true" data-td-fc-natural-position="9999" role="presentation" aria-hidden="true">',
          '<div class="product__modal-opener product__modal-opener--video no-js-hidden td-fc-gallery-video__placeholder" aria-hidden="true">',
          '<span class="product__media-icon motion-reduce quick-add-hidden">' + galleryVideoPlayIcon() + '</span>',
          '<div class="product__media media media--transparent gradient global-media-settings" style="padding-top:100%">',
          '<video class="td-fc-gallery-video__preview" muted playsinline webkit-playsinline preload="metadata" src="' + ENDING_GALLERY_VIDEO_URL + '#t=0.001" tabindex="-1" aria-hidden="true"></video>',
          '</div>',
          '</div>',
          '<deferred-media class="deferred-media gradient global-media-settings media no-js-hidden td-fc-gallery-video__stage" style="padding-top:100%" data-media-id="' + ENDING_GALLERY_SYNTHETIC_ID + '" data-autoplay-when-active="true" data-enable-audio-on-tap="true">',
          '<button id="Deferred-Poster-' + galleryMediaId + '" class="deferred-media__poster td-fc-gallery-video__poster" type="button" aria-label="Reproducir video de Funda Mágica">',
          '<span class="deferred-media__poster-button motion-reduce" aria-hidden="true">' + galleryVideoPlayIcon() + '</span>',
          '<span class="td-fc-gallery-video__poster-label" aria-hidden="true">Descubre el resultado completo</span>',
          '</button>',
          '<template><video muted playsinline webkit-playsinline loop preload="metadata" aria-label="Resultado completo de Funda Mágica"><source src="' + ENDING_GALLERY_VIDEO_URL + '" type="video/mp4"></video></template>',
          '</deferred-media>',
          '</li>'
        ].join('');
        slide = slideTemplate.content.firstElementChild;
        mediaList.appendChild(slide);
      }

      state.endingGalleryMediaId = ENDING_GALLERY_SYNTHETIC_ID;

      var thumbnailList = gallery.querySelector('[id^="Slider-Thumbnails-"]') || gallery.querySelector('.thumbnail-list');
      var thumbnail = gallery.querySelector('[data-td-fc-custom-ending-gallery-video-thumbnail="true"]');
      if (thumbnailList && !thumbnail) {
        thumbnail = document.createElement('li');
        thumbnail.id = 'Slide-Thumbnails-' + gallerySectionId + '-ending-video';
        thumbnail.className = 'thumbnail-list__item slider__slide td-fc-gallery-video__thumbnail';
        thumbnail.dataset.target = galleryMediaId;
        thumbnail.dataset.mediaPosition = '9999';
        thumbnail.dataset.mediaNaturalPosition = '9999';
        thumbnail.dataset.thumbnailInitialPosition = '9999';
        thumbnail.dataset.tdFcNaturalPosition = '9999';
        thumbnail.dataset.tdFcEndingGalleryVideo = 'true';
        thumbnail.dataset.tdFcCustomEndingGalleryVideoThumbnail = 'true';
        thumbnail.setAttribute('aria-hidden', 'false');

        var thumbnailButton = document.createElement('button');
        thumbnailButton.type = 'button';
        thumbnailButton.className = 'thumbnail global-media-settings global-media-settings--no-shadow td-fc-gallery-video__thumbnail-button';
        thumbnailButton.setAttribute('aria-label', 'Cargar el video final en la vista de la galería');
        thumbnailButton.setAttribute('aria-controls', 'GalleryViewer-' + gallerySectionId);
        thumbnailButton.innerHTML = [
          '<video muted playsinline webkit-playsinline preload="metadata" src="' + ENDING_GALLERY_VIDEO_URL + '#t=0.001" tabindex="-1" aria-hidden="true"></video>',
          '<span class="td-fc-gallery-video__thumbnail-content" aria-hidden="true">',
          '<span class="td-fc-gallery-video__thumbnail-icon">' + galleryVideoPlayIcon() + '</span>',
          '<span class="td-fc-gallery-video__thumbnail-label">Video</span>',
          '</span>'
        ].join('');
        thumbnailButton.addEventListener('click', function (event) {
          event.preventDefault();
          if (typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(galleryMediaId, false);
        });

        thumbnail.appendChild(thumbnailButton);
        thumbnailList.appendChild(thumbnail);
      }

      return slide;
    }

    function isPinnedGalleryVideo(element) {
      if (!element) return false;
      var mediaId = extractMediaId(element.dataset.mediaId || element.dataset.target);
      if (
        mediaId === PINNED_GALLERY_MEDIA_ID ||
        mediaId === PINNED_GALLERY_SYNTHETIC_ID ||
        (state.pinnedGalleryMediaId && mediaId === state.pinnedGalleryMediaId)
      ) {
        element.dataset.tdFcPinnedGalleryVideo = 'true';
        return true;
      }
      if (element.dataset.tdFcPinnedGalleryVideo === 'true') return true;
      if (element.dataset.tdFcPinnedGalleryVideo === 'false') return false;

      var template = element.querySelector('template');
      var descriptor = [
        mediaSourceDescriptor(element),
        template ? String(template.innerHTML || '').toLowerCase() : ''
      ].join(' ');
      var matches = descriptor.indexOf(PINNED_GALLERY_VIDEO_TOKEN) !== -1;

      if (matches && mediaId) state.pinnedGalleryMediaId = mediaId;
      element.dataset.tdFcPinnedGalleryVideo = String(matches);
      return matches;
    }

    function isEndingGalleryVideo(element) {
      if (!element) return false;
      var mediaId = extractMediaId(element.dataset.mediaId || element.dataset.target);
      if (
        mediaId === ENDING_GALLERY_SYNTHETIC_ID ||
        (state.endingGalleryMediaId && mediaId === state.endingGalleryMediaId)
      ) {
        element.dataset.tdFcEndingGalleryVideo = 'true';
        return true;
      }
      if (element.dataset.tdFcEndingGalleryVideo === 'true') return true;
      if (element.dataset.tdFcEndingGalleryVideo === 'false') return false;

      var template = element.querySelector('template');
      var descriptor = [
        mediaSourceDescriptor(element),
        template ? String(template.innerHTML || '').toLowerCase() : ''
      ].join(' ');
      var matches = descriptor.indexOf(ENDING_GALLERY_VIDEO_TOKEN) !== -1;

      if (matches && mediaId) state.endingGalleryMediaId = mediaId;
      element.dataset.tdFcEndingGalleryVideo = String(matches);
      return matches;
    }

    function configurationFromDescriptor(descriptor) {
      if (descriptor.indexOf('seccional') !== -1 || /\bfunda\s+l\b/.test(descriptor)) return 'sectional';
      if (/\b3\s+cuerpos?\b/.test(descriptor)) return 'three';
      if (/\b2\s+cuerpos?\b/.test(descriptor)) return 'two';
      return '';
    }

    function colorFromDescriptor(descriptor) {
      if (/\bgris\s+oscuro\b/.test(descriptor)) return 'gris-oscuro';
      if (/\bgris\s+claro\b/.test(descriptor)) return 'gris-claro';
      if (/\bcafe\s+oscuro\b/.test(descriptor)) return 'cafe-oscuro';
      if (/\bcaqui\b/.test(descriptor)) return 'caqui';
      if (/\b(?:crema|beige|cafe\s+claro)\b/.test(descriptor)) return 'crema';
      if (/\bblanco\b/.test(descriptor)) return 'blanco';
      if (/\bnegro\b/.test(descriptor)) return 'negro';
      return '';
    }

    function inferredMediaConfiguration(element) {
      return configurationFromDescriptor(mediaSourceDescriptor(element)) ||
        configurationFromDescriptor(mediaDescriptor(element));
    }

    function inferredMediaColor(element) {
      var sourceColor = colorFromDescriptor(mediaSourceDescriptor(element));
      if (sourceColor) return sourceColor;

      var taggedColor = readMediaColor(element);
      if (taggedColor) return taggedColor;

      return colorFromDescriptor(mediaDescriptor(element));
    }

    function trustedVariantMediaIds(items, targetMediaId, selectedColor, configuration) {
      var mediaGroups = galleryConfig && galleryConfig.mediaGroups ? galleryConfig.mediaGroups : {};
      var orderedItems = items.slice().sort(function (left, right) {
        return naturalMediaPosition(left, items.indexOf(left)) - naturalMediaPosition(right, items.indexOf(right));
      });
      var trusted = {};
      var groupStarted = false;

      orderedItems.some(function (element) {
        var mediaId = extractMediaId(element.dataset.mediaId || element.dataset.target);
        var group = mediaGroups[mediaId] != null ? String(mediaGroups[mediaId]) : '';

        if (mediaId === targetMediaId) {
          trusted[mediaId] = true;
          groupStarted = true;
          return false;
        }

        if (isPinnedGalleryVideo(element) || isEndingGalleryVideo(element)) return false;
        if (!groupStarted) return false;
        if (group !== targetMediaId) return true;

        var mediaColor = inferredMediaColor(element);
        var mediaConfiguration = inferredMediaConfiguration(element);
        var colorConflict = mediaColor && mediaColor !== 'shared' && mediaColor !== selectedColor;
        var configurationConflict = mediaConfiguration && mediaConfiguration !== configuration;

        if (colorConflict || configurationConflict) return true;
        trusted[mediaId] = true;
        return false;
      });

      trusted[targetMediaId] = true;
      return trusted;
    }

    function mediaIsVisible(element, targetMediaId, selectedColor, configuration, trustedMediaIds) {
      if (isPinnedGalleryVideo(element) || isEndingGalleryVideo(element)) return true;

      var mediaId = extractMediaId(element.dataset.mediaId || element.dataset.target);
      if (mediaId === targetMediaId) return true;

      var mediaConfiguration = inferredMediaConfiguration(element);
      if (mediaConfiguration && mediaConfiguration !== configuration) return false;

      var mediaColor = inferredMediaColor(element);
      if (mediaColor && mediaColor !== 'shared' && mediaColor !== selectedColor) return false;

      var taggedColor = readMediaColor(element);
      if (taggedColor) return taggedColor === selectedColor || taggedColor === 'shared';

      var mediaGroups = galleryConfig && galleryConfig.mediaGroups ? galleryConfig.mediaGroups : {};
      var group = mediaGroups[mediaId];
      if (group != null) {
        if (String(group) === targetMediaId) return Boolean(trustedMediaIds && trustedMediaIds[mediaId]);
        return String(group) === 'shared';
      }

      return Object.keys(mediaGroups).length === 0;
    }

    function naturalMediaPosition(element, fallbackIndex) {
      var storedPosition = parseInt(element.dataset.tdFcNaturalPosition, 10);
      if (Number.isFinite(storedPosition)) return storedPosition;

      var sourcePosition = parseInt(
        element.dataset.mediaNaturalPosition || element.dataset.mediaPosition,
        10
      );
      var naturalPosition = Number.isFinite(sourcePosition) ? sourcePosition : fallbackIndex + 1;
      element.dataset.tdFcNaturalPosition = String(naturalPosition);
      return naturalPosition;
    }

    function synchronizeNaturalMediaPositions(slides, thumbs) {
      thumbs.forEach(function (thumb, index) {
        var mediaId = extractMediaId(thumb.dataset.target);
        if (!mediaId) return;
        state.mediaNaturalPositions[mediaId] = naturalMediaPosition(thumb, index);
      });

      slides.forEach(function (slide, index) {
        var mediaId = extractMediaId(slide.dataset.mediaId);
        var knownPosition = state.mediaNaturalPositions[mediaId];
        if (Number.isFinite(knownPosition)) {
          slide.dataset.tdFcNaturalPosition = String(knownPosition);
        } else {
          state.mediaNaturalPositions[mediaId] = naturalMediaPosition(slide, index);
        }
      });
    }

    function applyKnownNaturalPositions(items) {
      items.forEach(function (item, index) {
        var mediaId = extractMediaId(item.dataset.mediaId || item.dataset.target);
        var knownPosition = state.mediaNaturalPositions[mediaId];
        if (Number.isFinite(knownPosition)) {
          item.dataset.tdFcNaturalPosition = String(knownPosition);
        } else {
          state.mediaNaturalPositions[mediaId] = naturalMediaPosition(item, index);
        }
      });
    }

    function prioritizeMediaItems(items, targetMediaId, selectedColor, updateThumbnailOrder, trustedMediaIds) {
      var mediaGroups = galleryConfig && galleryConfig.mediaGroups ? galleryConfig.mediaGroups : {};
      var rankedItems = items.map(function (element, index) {
        var mediaId = extractMediaId(element.dataset.mediaId || element.dataset.target);
        var mediaColor = inferredMediaColor(element);
        var group = mediaGroups[mediaId] != null ? String(mediaGroups[mediaId]) : '';
        var pinnedVideo = isPinnedGalleryVideo(element);
        var endingVideo = isEndingGalleryVideo(element);
        var visible = !element.hidden && element.style.display !== 'none';
        var priority = 5;

        if (!visible) {
          priority = 7;
        } else if (endingVideo) {
          priority = 6;
        } else if (mediaId === targetMediaId) {
          priority = 0;
        } else if (pinnedVideo) {
          priority = 1;
        } else if (group === targetMediaId && trustedMediaIds && trustedMediaIds[mediaId]) {
          priority = 2;
        } else if (mediaColor === selectedColor) {
          priority = 3;
        } else if (mediaColor === 'shared' || group === 'shared') {
          priority = 4;
        }

        return {
          element: element,
          priority: priority,
          naturalPosition: naturalMediaPosition(element, index)
        };
      });

      rankedItems.sort(function (left, right) {
        if (left.priority !== right.priority) return left.priority - right.priority;
        return left.naturalPosition - right.naturalPosition;
      });

      var parent = rankedItems.length ? rankedItems[0].element.parentElement : null;
      if (!parent) return items;

      rankedItems.forEach(function (entry, index) {
        if (updateThumbnailOrder) {
          var displayPosition = String(index + 1);
          var thumbnailButton = entry.element.querySelector('button[aria-label]');
          entry.element.dataset.mediaNaturalPosition = displayPosition;
          entry.element.dataset.mediaPosition = displayPosition;
          if (thumbnailButton) {
            thumbnailButton.setAttribute(
              'aria-label',
              (thumbnailButton.getAttribute('aria-label') || '').replace(/\d+/, displayPosition)
            );
          }
        }
        parent.appendChild(entry.element);
      });

      return rankedItems.map(function (entry) { return entry.element; });
    }

    function refreshGallery(gallery, variant, colorLabel) {
      var targetMediaId = String(variant.featuredMediaId || '');
      var selectedColor = normalizeMediaColor(colorLabel);
      if (!targetMediaId || !selectedColor) return;

      ensurePinnedGalleryVideo(gallery);
      ensureEndingGalleryVideo(gallery);

      var slides = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item[data-media-id]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item[data-target]'));
      var targetSlide = slides.find(function (slide) {
        return extractMediaId(slide.dataset.mediaId) === targetMediaId;
      });

      if (!targetSlide) return;

      synchronizeNaturalMediaPositions(slides, thumbs);

      var trustedMediaIds = trustedVariantMediaIds(
        slides,
        targetMediaId,
        selectedColor,
        variant.configuration
      );

      slides.forEach(function (slide) {
        setMediaVisible(slide, mediaIsVisible(
          slide,
          targetMediaId,
          selectedColor,
          variant.configuration,
          trustedMediaIds
        ));
      });
      thumbs.forEach(function (thumb) {
        setMediaVisible(thumb, mediaIsVisible(
          thumb,
          targetMediaId,
          selectedColor,
          variant.configuration,
          trustedMediaIds
        ));
      });

      setMediaVisible(targetSlide, true);
      var targetThumb = thumbs.find(function (thumb) {
        return extractMediaId(thumb.dataset.target) === targetMediaId;
      });
      if (targetThumb) setMediaVisible(targetThumb, true);

      var orderedSlides = prioritizeMediaItems(slides, targetMediaId, selectedColor, false, trustedMediaIds);
      prioritizeMediaItems(thumbs, targetMediaId, selectedColor, true, trustedMediaIds);

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(targetSlide.dataset.mediaId, false);
      } else if (targetThumb) {
        var targetButton = targetThumb.querySelector('button');
        if (targetButton && typeof targetButton.click === 'function') targetButton.click();
      } else {
        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide === targetSlide);
        });
      }

      var visibleSlides = orderedSlides.filter(function (slide) {
        return !slide.hidden && slide.style.display !== 'none';
      });
      var viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
      var thumbnails = gallery.querySelector('slider-component[id^="GalleryThumbnails-"]');

      [viewer, thumbnails].forEach(function (slider) {
        if (!slider) return;
        if (typeof slider.resetPages === 'function') {
          slider.resetPages();
        } else if (typeof slider.initPages === 'function') {
          slider.initPages();
        }
      });

      var currentCounter = gallery.querySelector('.slider-counter--current');
      var totalCounter = gallery.querySelector('.slider-counter--total');
      if (currentCounter) currentCounter.textContent = '1';
      if (totalCounter) totalCounter.textContent = String(visibleSlides.length);

      if (typeof gallery.updateActiveThumbnailVisibility === 'function') {
        gallery.updateActiveThumbnailVisibility(targetThumb || null);
      }
      if (typeof gallery.scheduleDesktopViewerNavigationSync === 'function') {
        gallery.scheduleDesktopViewerNavigationSync();
      }

      gallery.dataset.tdFcActiveHostVariant = String(variant.id || '');
      gallery.dataset.tdFcActiveMedia = targetMediaId;
    }

    function syncProductModal(variant, colorLabel) {
      if (!sectionId) return;
      var modal = document.getElementById('ProductModal-' + sectionId);
      var content = modal && modal.querySelector('.product-media-modal__content');
      if (!content) return;

      var targetMediaId = String(variant.featuredMediaId || '');
      var selectedColor = normalizeMediaColor(colorLabel);
      var items = Array.prototype.slice.call(content.children).filter(function (item) {
        if (!item.matches('[data-media-id]')) return false;
        var offer = item.dataset.tdOfferMedia;
        return !offer || offer === 'solo';
      });
      var targetItem = items.find(function (item) {
        return extractMediaId(item.dataset.mediaId) === targetMediaId;
      });

      if (!targetItem) return;

      applyKnownNaturalPositions(items);

      var trustedMediaIds = trustedVariantMediaIds(
        items,
        targetMediaId,
        selectedColor,
        variant.configuration
      );

      items.forEach(function (item) {
        var visible = mediaIsVisible(
          item,
          targetMediaId,
          selectedColor,
          variant.configuration,
          trustedMediaIds
        );
        setMediaVisible(item, visible);
        item.classList.remove('active');
      });

      setMediaVisible(targetItem, true);
      targetItem.classList.add('active');
      prioritizeMediaItems(items, targetMediaId, selectedColor, false, trustedMediaIds);
      if (typeof modal.refreshMedia === 'function') modal.refreshMedia();
    }

    function syncCollectionPreview(variant, colorLabel) {
      if (!elements.media || !elements.mediaImage || !root.closest('[data-td-funda-modal]')) return;
      if (!variant.featuredMediaUrl) {
        elements.media.hidden = true;
        return;
      }

      var configurationLabel = PRESETS[variant.configuration]
        ? PRESETS[variant.configuration].label
        : PRESETS[state.preset].label;
      var nextAlt = 'Funda Mágica para ' + configurationLabel + ' en color ' + colorLabel;

      elements.media.hidden = false;
      elements.mediaImage.alt = nextAlt;
      if (elements.mediaCaption) elements.mediaCaption.textContent = configurationLabel + ' · ' + colorLabel;

      if (elements.mediaImage.getAttribute('src') !== variant.featuredMediaUrl) {
        elements.media.classList.add('is-loading');
        elements.mediaImage.onload = function () { elements.media.classList.remove('is-loading'); };
        elements.mediaImage.onerror = function () { elements.media.classList.remove('is-loading'); };
        elements.mediaImage.setAttribute('src', variant.featuredMediaUrl);
      }
    }

    function applyHostVariantMedia(counts) {
      if (!hostMediaModel.length || !state.color) return;

      var colorLabel = model.colorLabels[state.color];
      var variant = findHostMediaVariant(hostMediaModel, state.preset, counts, colorLabel);
      if (!variant) {
        state.selectedHostVariant = null;
        delete root.dataset.tdFcHostVariantId;
        delete root.dataset.tdFcHostMediaId;
        if (elements.media) elements.media.hidden = true;
        return;
      }

      state.selectedHostVariant = variant;
      root.dataset.tdFcHostVariantId = String(variant.id || '');
      root.dataset.tdFcHostMediaId = String(variant.featuredMediaId || '');

      syncCollectionPreview(variant, colorLabel);

      var section = sectionId ? document.getElementById('MainProduct-' + sectionId) : null;
      if (section) {
        Array.prototype.slice.call(section.querySelectorAll('media-gallery')).forEach(function (gallery) {
          var offer = gallery.dataset.tdOfferGallery;
          if (!offer || offer === 'solo') refreshGallery(gallery, variant, colorLabel);
        });
        syncProductModal(variant, colorLabel);
      }

      root.dispatchEvent(new CustomEvent('td:funda-visual-variant-change', {
        bubbles: true,
        detail: {
          sectionId: sectionId,
          hostVariantId: String(variant.id || ''),
          featuredMediaId: String(variant.featuredMediaId || ''),
          configuration: variant.configuration,
          color: colorLabel
        }
      }));
    }

    function scheduleHostVariantMedia(counts) {
      if (state.mediaFrame != null && typeof window.cancelAnimationFrame === 'function') {
        window.cancelAnimationFrame(state.mediaFrame);
      }
      state.mediaFrame = window.requestAnimationFrame(function () {
        state.mediaFrame = null;
        applyHostVariantMedia(counts);
      });
    }

    function isColorAvailable(color, counts) {
      return Boolean(planSolution(model, counts, color));
    }

    function firstAvailableColor(counts) {
      return model.colors.find(function (color) {
        return isColorAvailable(color, counts);
      }) || null;
    }

    function totals(solution) {
      return {
        price: solution ? solution.price : 0,
        compare: solution ? solution.compare : 0
      };
    }

    function showError(message) {
      if (elements.errorMessage) elements.errorMessage.textContent = message || '';
      if (!elements.error) return;
      elements.error.hidden = !message;
    }

    function colorHex(colorKey) {
      return COLOR_STYLES[colorKey] || COLOR_STYLES[normalize(model.colorLabels[colorKey])] || '#d9d4cb';
    }

    function renderColorOptions(counts) {
      elements.colors.innerHTML = '';

      model.colors.forEach(function (colorKey) {
        var label = model.colorLabels[colorKey];
        var available = isColorAvailable(colorKey, counts);
        var button = document.createElement('button');
        var dot = document.createElement('span');
        var text = document.createElement('span');

        button.type = 'button';
        button.className = 'td-funda-complete__color';
        button.dataset.color = colorKey;
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-label', label + (available ? '' : ', agotado para esta configuración'));
        button.setAttribute('aria-checked', String(state.color === colorKey));
        button.tabIndex = state.color === colorKey ? 0 : -1;
        button.disabled = !available;

        if (state.color === colorKey) button.classList.add('is-selected');
        if (!available) button.classList.add('is-unavailable');

        dot.className = 'td-funda-complete__color-dot';
        dot.style.setProperty('--td-color', colorHex(colorKey));
        text.className = 'td-funda-complete__color-label';
        text.textContent = label;

        button.appendChild(dot);
        button.appendChild(text);
        button.addEventListener('click', function () {
          if (!available || state.loading) return;
          var restoreFocus = document.activeElement === button;
          state.color = colorKey;
          showError('');
          render();
          if (restoreFocus) {
            window.requestAnimationFrame(function () {
              var replacement = Array.prototype.slice.call(elements.colors.querySelectorAll('[role="radio"]')).find(function (colorButton) {
                return colorButton.dataset.color === colorKey;
              });
              if (replacement) replacement.focus({ preventScroll: true });
            });
          }
        });
        button.addEventListener('keydown', function (event) {
          handleRadioKeys(event, Array.prototype.slice.call(elements.colors.querySelectorAll('[role="radio"]')));
        });
        elements.colors.appendChild(button);
      });
    }

    function renderPresetButtons() {
      elements.presetButtons.forEach(function (button) {
        var selected = button.dataset.tdFcPreset === state.preset;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-checked', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
    }

    function renderSteppers() {
      elements.customPanel.hidden = state.preset !== 'custom';
      elements.steppers.forEach(function (stepper) {
        var piece = stepper.dataset.tdFcStepper;
        var input = stepper.querySelector('input');
        var minus = stepper.querySelector('[data-action="minus"]');
        var plus = stepper.querySelector('[data-action="plus"]');
        var value = state.customCounts[piece];
        input.value = value;
        minus.disabled = value <= Number(input.min || 0);
        plus.disabled = value >= Number(input.max || 8);
      });
    }

    function renderSummary(counts, calculated, solution) {
      var count = totalPieces(counts);
      elements.summaryName.textContent = PRESETS[state.preset].label;
      elements.summaryCount.textContent = count + (count === 1 ? ' funda' : ' fundas');
      elements.summaryLines.innerHTML = '';

      Object.keys(PIECES).forEach(function (piece) {
        var quantity = counts[piece];
        if (!quantity) return;

        var piecePlan = solution && solution.plans[piece];
        var item = document.createElement('li');
        var label = document.createElement('span');
        var price = document.createElement('span');
        label.textContent = quantity + ' ' + (quantity === 1 ? PIECES[piece].singular : PIECES[piece].plural);
        price.textContent = piecePlan ? money(piecePlan.price) : 'No disponible';
        item.appendChild(label);
        item.appendChild(price);
        elements.summaryLines.appendChild(item);
      });

      elements.total.textContent = money(calculated.price);
      if (calculated.compare > calculated.price) {
        elements.compare.textContent = money(calculated.compare);
        elements.compare.hidden = false;
      } else {
        elements.compare.hidden = true;
      }
    }

    function renderShipping(total) {
      var threshold = Number(config.freeShippingThreshold || 0);
      if (!threshold) {
        elements.shipping.hidden = true;
        return;
      }

      elements.shipping.hidden = false;
      var status = shippingState(total, threshold);
      elements.shipping.classList.toggle('is-complete', status.complete);
      elements.shippingProgress.style.width = status.progress + '%';

      if (status.complete) {
        elements.shippingText.textContent = '✓ Esta solución obtiene envío gratis';
        elements.shippingAmount.textContent = '';
      } else {
        elements.shippingText.textContent = 'Envío gratis desde ' + money(threshold);
        elements.shippingAmount.textContent = 'Te faltan ' + money(status.remaining);
      }
    }

    function renderSubmit(counts, calculated, solution) {
      var count = totalPieces(counts);
      var valid = count > 0 && Boolean(solution);
      elements.submit.disabled = !valid || state.loading;
      elements.submit.classList.toggle('is-loading', state.loading);

      if (state.loading) {
        elements.submitLabel.textContent = 'Agregando tu solución…';
      } else if (!count) {
        elements.submitLabel.textContent = 'Elige al menos una funda';
      } else if (!state.color || !solution) {
        elements.submitLabel.textContent = 'Elige un color disponible';
      } else {
        elements.submitLabel.textContent = 'Agregar solución · ' + money(calculated.price);
      }
    }

    function render() {
      var counts = getCounts();
      if (!state.color || !isColorAvailable(state.color, counts)) {
        state.color = firstAvailableColor(counts);
      }

      renderPresetButtons();
      renderSteppers();
      renderColorOptions(counts);
      elements.colorName.textContent = state.color ? model.colorLabels[state.color] : 'Sin disponibilidad';

      var solution = planSolution(model, counts, state.color);
      var calculated = totals(solution);
      renderSummary(counts, calculated, solution);
      renderShipping(calculated.price);
      renderSubmit(counts, calculated, solution);
      scheduleHostVariantMedia(counts);
    }

    function updateCustomCount(stepper, nextValue) {
      var input = stepper.querySelector('input');
      var piece = stepper.dataset.tdFcStepper;
      state.customCounts[piece] = clamp(nextValue, Number(input.min || 0), Number(input.max || 8));
      showError('');
      render();
    }

    function getCartUi() {
      return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    }

    function cartSections(cart) {
      if (cart && typeof cart.getSectionsToRender === 'function') {
        return cart.getSectionsToRender().map(function (section) { return section.id; });
      }
      return ['cart-drawer', 'cart-icon-bubble'];
    }

    function hasCartSections(response, requiredSections) {
      if (!response || !response.sections || typeof response.sections !== 'object') return false;
      return requiredSections.every(function (sectionId) {
        return typeof response.sections[sectionId] === 'string' && response.sections[sectionId].trim().length > 0;
      });
    }

    function renderCart(response, cart, requiredSections) {
      if (cart && hasCartSections(response, requiredSections) && typeof cart.renderContents === 'function') {
        // Shopify's multi-item response exposes `items[]` instead of the
        // single-item `key` expected by Dawn's cart-notification component.
        // Normalising both fields keeps drawer and notification cart modes
        // working without a second request.
        if (!response.key && response.items && response.items[0]) {
          response.key = response.items[0].key;
          response.id = response.id || response.items[0].id;
        }
        try {
          cart.classList.remove('is-empty');
          var drawerInner = cart.querySelector('.drawer__inner');
          if (drawerInner) drawerInner.classList.remove('is-empty');
          cart.renderContents(response);
          return true;
        } catch (error) {
          console.error('No pudimos actualizar el carrito visualmente.', error);
          return false;
        }
      }
      return false;
    }

    function cartItemSignature(item) {
      var properties = item.properties || {};
      return [
        String(item.variant_id || item.id || ''),
        String(properties._td_piece || ''),
        String(properties._td_pack_size || '')
      ].join('|');
    }

    function bundleStatus(cartState, bundleKey, expectedItems) {
      var actual = {};
      var found = false;

      (cartState && Array.isArray(cartState.items) ? cartState.items : []).forEach(function (item) {
        var properties = item.properties || {};
        if (String(properties._td_bundle_key || '') !== bundleKey) return;
        found = true;
        var signature = cartItemSignature(item);
        actual[signature] = (actual[signature] || 0) + Number(item.quantity || 0);
      });

      var expected = {};
      expectedItems.forEach(function (item) {
        var signature = cartItemSignature(item);
        expected[signature] = (expected[signature] || 0) + Number(item.quantity || 0);
      });

      var complete = Object.keys(expected).every(function (signature) {
        return Number(actual[signature] || 0) >= expected[signature];
      });

      return { found: found, complete: found && complete };
    }

    function cartStateUrl(shopRoot) {
      return String(shopRoot || '/').replace(/\/?$/, '/') + 'cart.js';
    }

    function recoverUncertainAdd(shopRoot, cartUrl, bundleKey, expectedItems, originalError, counts, calculated, solution) {
      fetch(cartStateUrl(shopRoot), {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('No pudimos comprobar el carrito.');
          return response.json();
        })
        .then(function (cartState) {
          var status = bundleStatus(cartState, bundleKey, expectedItems);

          if (status.complete) {
            state.pendingBundleKey = null;
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(analyticsPayload(counts, calculated.price));
            window.location.assign(cartUrl);
            return;
          }

          if (status.found) {
            state.pendingBundleKey = null;
            showError('Shopify alcanzó a agregar parte de la solución. Te llevamos al carrito para revisarla sin duplicar productos.');
            window.setTimeout(function () { window.location.assign(cartUrl); }, 900);
            return;
          }

          state.pendingBundleKey = null;
          state.loading = false;
          showError(originalError.message || 'Ocurrió un problema. Inténtalo nuevamente.');
          renderSubmit(counts, calculated, solution);
        })
        .catch(function () {
          state.pendingBundleKey = null;
          showError('La conexión se interrumpió y no pudimos confirmar el carrito. Te llevamos a revisarlo para evitar duplicados.');
          window.setTimeout(function () { window.location.assign(cartUrl); }, 900);
        });
    }

    function analyticsPayload(counts, total) {
      return {
        event: 'td_funda_solution_added',
        product_id: String(config.hostProductId),
        configuration: state.preset,
        color: model.colorLabels[state.color],
        seat_qty: counts.seat,
        back_qty: counts.back,
        chaise_qty: counts.chaise,
        value: total / 100,
        currency: config.currency || 'CLP'
      };
    }

    function addSolution() {
      if (state.loading) return;

      var counts = getCounts();
      var solution = planSolution(model, counts, state.color);
      var calculated = totals(solution);
      var colorLabel = model.colorLabels[state.color];
      var bundleKey = state.pendingBundleKey || ('funda-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8));
      var routes = window.routes || {};
      var shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var displayMetadata = bundleDisplayMetadata(counts, colorLabel, shopRoot);
      var items = [];
      var cart = getCartUi();

      if (solution && totalPieces(counts) > 0) {
        Object.keys(solution.plans).forEach(function (piece) {
          solution.plans[piece].items.forEach(function (plannedItem) {
            var properties = {
              'Configuración': PRESETS[state.preset].label,
              '_td_solution': 'funda_magica_complete',
              '_td_solution_product_id': String(config.hostProductId),
              '_td_bundle_key': bundleKey,
              '_td_piece': piece,
              '_td_color': colorLabel,
              '_td_pack_size': String(plannedItem.packSize),
              '_td_units': String(plannedItem.packSize * plannedItem.quantity)
            };

            Object.keys(displayMetadata).forEach(function (property) {
              properties[property] = displayMetadata[property];
            });

            items.push({
              id: Number(plannedItem.variant.id),
              quantity: plannedItem.quantity,
              properties: properties
            });
          });
        });
      }

      if (!solution || totalPieces(counts) < 1 || !items.length) {
        showError('No pudimos completar esta combinación. Prueba con otro color.');
        return;
      }

      state.loading = true;
      state.pendingBundleKey = bundleKey;
      showError('');
      renderSubmit(counts, calculated, solution);

      var addUrl = routes.cart_add_url || (shopRoot + 'cart/add.js');
      var requiredSections = cartSections(cart);
      var cartUrl = routes.cart_url || (shopRoot + 'cart');
      var body = {
        items: items,
        sections: requiredSections,
        sections_url: window.location.pathname
      };

      if (cart && typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok || data.status) throw new Error(data.description || data.message || 'No pudimos agregar la solución.');
            return data;
          });
        })
        .then(function (data) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(analyticsPayload(counts, calculated.price));
          root.dispatchEvent(new CustomEvent('td:funda-solution-added', {
            bubbles: true,
            detail: analyticsPayload(counts, calculated.price)
          }));

          state.loading = false;
          state.pendingBundleKey = null;
          render();
          if (!renderCart(data, cart, requiredSections)) window.location.assign(cartUrl);
        })
        .catch(function (error) {
          recoverUncertainAdd(shopRoot, cartUrl, bundleKey, items, error, counts, calculated, solution);
        });
    }

    elements.presetButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (state.loading) return;
        var nextPreset = button.dataset.tdFcPreset;
        if (!PRESETS[nextPreset] || nextPreset === state.preset) return;
        if (nextPreset === 'custom' && state.preset !== 'custom') state.customCounts = getCounts();
        state.preset = nextPreset;
        showError('');
        render();

        if (nextPreset === 'custom') {
          window.requestAnimationFrame(function () {
            var firstInput = elements.customPanel.querySelector('input');
            if (firstInput) firstInput.focus({ preventScroll: true });
          });
        }
      });
      button.addEventListener('keydown', function (event) {
        handleRadioKeys(event, elements.presetButtons);
      });
    });

    elements.steppers.forEach(function (stepper) {
      var input = stepper.querySelector('input');
      stepper.addEventListener('click', function (event) {
        var action = event.target.closest('[data-action]');
        if (!action || state.loading) return;
        var direction = action.dataset.action === 'plus' ? 1 : -1;
        updateCustomCount(stepper, Number(input.value) + direction);
      });
      input.addEventListener('change', function () {
        updateCustomCount(stepper, input.value);
      });
      input.addEventListener('input', function () {
        if (input.value === '') return;
        updateCustomCount(stepper, input.value);
      });
    });

    elements.submit.addEventListener('click', addSolution);

    document.addEventListener('td:product-modal-built', function (event) {
      if (!event.detail || String(event.detail.sectionId || '') !== String(sectionId)) return;
      if (state.selectedHostVariant && state.color) {
        syncProductModal(state.selectedHostVariant, model.colorLabels[state.color]);
      }
    });

    state.color = firstAvailableColor(PRESETS.two.counts);
    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-td-funda-complete]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();